var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { ConfirmationModal } from "../../../../Components/UI/ConfirmationModal";
import { Translate } from "../../../../../I18N";









const DeleteTemplatesConfirmationModal = ({
  open,
  onAccept,
  onCancel,
  templates
}) => {
  if (!open) return null;

  return (/*#__PURE__*/
    _jsx(ConfirmationModal, {
      header: /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete"),
      warningText: /*#__PURE__*/_jsx(Translate, {}, void 0, "Do you want to delete the following items?"),
      body: /*#__PURE__*/
      _jsx("ul", { className: "flex flex-wrap max-w-md gap-8 list-disc list-inside" }, void 0,
      templates.map((item) => /*#__PURE__*/
      _jsx("li", {}, item.name, item.name)
      )
      ),

      acceptButton: /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete"),
      cancelButton: /*#__PURE__*/_jsx(Translate, {}, void 0, "Cancel"),
      onAcceptClick: () => onAccept(templates),
      onCancelClick: onCancel,
      dangerStyle: true }
    ));

};

export { DeleteTemplatesConfirmationModal };